import React, { useState, useEffect } from 'react';

const YouTubeEmbedder = (props) => {
    const { setGroup, realContent, isOpen } = props;
  const [inputUrl, setInputUrl] = useState('');
  const [embedUrl, setEmbedUrl] = useState('');

  useEffect(() => {
    if (isOpen) {
        if (realContent !== embedUrl) {
            if(embedUrl.length !== 0) {
                setGroup(prevGroup => ({ ...prevGroup, blockContent: embedUrl }));
            } else {
                setEmbedUrl(realContent);
            }
        }
    } else {
        setGroup(prevGroup => ({ ...prevGroup, blockContent: '' }));
        setEmbedUrl('');  // Clear the content when the window is closed
    }
}, [embedUrl, realContent, setGroup, isOpen]);

  // Function to extract video ID from the YouTube link
  const extractVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|embed\/|watch\?v=|watch\?.*?&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  function handleChange(e) {
    setInputUrl(e.target.value)
    const videoId = extractVideoId(e.target.value);
    if (videoId) {
      setEmbedUrl(`https://www.youtube.com/embed/${videoId}`);
    } else {
      alert('Invalid YouTube URL');
    }
  }

  return (
    <div>
        <div id="youtube-search-container">
            <input
            type="text"
            placeholder="enter youtube url"
            value={inputUrl}
            onChange={handleChange}
            />
        </div>

      {embedUrl && (
        <div style={{ marginTop: '20px' }}>
          <iframe
            width={window.screen.width * 0.4}
            height={window.screen.width * 0.225}
            src={embedUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded YouTube Video"
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default YouTubeEmbedder;